document.addEventListener('click', (event) => {
  const filterButton = event.target.closest('[data-open-mobile-facets]');
  if (!filterButton) return;

  const section = filterButton.closest('.collection-grid-section');
  const summary = section?.querySelector('.mobile-facets__wrapper > details > summary');
  if (summary) summary.click();
});

document.addEventListener('change', (event) => {
  const sortSelect = event.target.closest('[data-collection-sort-select]');
  if (!sortSelect) return;

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('sort_by', sortSelect.value);

  if (typeof FacetFiltersForm !== 'undefined') {
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  } else {
    window.location.search = searchParams.toString();
  }
});
